export const AuthActionType = Object.freeze({
    LOADING_AUTH: 'Authorization:: Set application busy',
    SET_AUTH: 'Authorization:: Set user logged in status',
    SET_ROLE: 'Authorization:: Set user role',
    SET_REGISTRATION: 'Registration:: set registration data',
    SET_INVITE_DATA: 'Registration:: Set the invite information',
    SET_USER_DATA: 'Authorization:: Set user data',
    SET_FETCHING: 'Authorization:: Set fetching',
    AUTH_ERROR: 'Authorization error',
    SET_VERIFIED: 'Authorization:: Set user verified status',
    SET_TWO_FACTOR_AUTH: 'Authorization:: Set two factor authentication',
    RESET_DATA: 'Authorization:: Reset authentication'
})

export const AuthResponseStatus = Object.freeze({
    ACTIVE: 'warning',
    PENDING_ACTIVATION: 'warning',
    PENDING_EMAIL_VERIFICATION: 'warning',
    DENIED: 'warning',
})

export const REGISTRATION_SUCCESSFUL = 'Succesfully created user'

export const UNAUTHORIZED_USER_RESPONSE =
    'You have not verified your email. Please check your email for verification link'
